import { Spin, Modal } from 'antd';
import React, { useState } from 'react';
import UnitForm from './UnitForm';
import { updateUnit } from '../../services/unitService';
import { getSubunitIDList } from '../../utilities/subunitFormat';

function UnitEdit(props) {
  const unit = props.unit;

  const initialValues = {
    code: unit?.code,
    title: unit?.title,
    description: unit?.description,
    longDescription: unit?.longDescription,
    imgData: unit?.imgData,
    sectionNumber: unit?.sectionNumber,
    subunits: getSubunitIDList(unit?.subunits),
    headerOfTheDay: unit?.headerOfTheDay,
    descOfTheDay: unit?.descOfTheDay
  };

  const [status, setStatus] = useState({
    type: 'IDLE',
    message: 'In idle mode'
  });

  const onSubmit = async (values) => {
    let payload = {
      ...values
    };

    await updateUnit(unit.unitId, payload)
      .then((response) => {
        console.log('Successfully Updated! ', response);
        setStatus({
          type: 'SUCCESS',
          message: 'Data updated successfully!'
        });
      })
      .catch((error) => {
        alert('Posting data from the backend failed!');
        if (error?.response?.data?.message)
          setStatus({
            type: 'ERROR',
            message: error.response.data.message
          });
        else
          setStatus({ type: 'ERROR', message: 'Something went wrong!' });
      });
  };

  return (
    <Modal
      title={`Edit Unit ${unit.code}`}
      visible={props.isOpen}
      onCancel={() => props.toggle()}
      footer={null}>
      {status.type === 'LOADING' ? (
        <Spin size="large" />
      ) : (
        <UnitForm
          type="Update"
          currentSubunits={unit?.subunits}
          initialValues={initialValues}
          onSubmit={onSubmit}
          status={status}
          visible={props.isOpen}
        />
      )}
    </Modal>
  );
}

export default UnitEdit;
